import { render, staticRenderFns } from "./BookingFees.vue?vue&type=template&id=95be22cc&"
import script from "./BookingFees.vue?vue&type=script&lang=js&"
export * from "./BookingFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports